// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselCustomArrows-module__arrow___ImpWb","leftArrow":"CarouselCustomArrows-module__leftArrow___dGRQk","rightArrow":"CarouselCustomArrows-module__rightArrow___EBJMW"};